import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { CALYPSO, CALYPSO_DARK } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Tracker } from '../../store/tracking/action-creators';
import { StyledUILink } from '../TextInput.styles';
const ScrollToCtaContainer = styled(UIFlex).withConfig({
  displayName: "ScrollToCta__ScrollToCtaContainer",
  componentId: "sc-1dj4sq2-0"
})(["transform:translateY(-50px);grid-column-end:span 5;"]);
const ScrollToCtaText = styled(FormattedMessage).withConfig({
  displayName: "ScrollToCta__ScrollToCtaText",
  componentId: "sc-1dj4sq2-1"
})(["color:", ";font-size:14px;font-weight:600;&:hover{color:", ";}"], CALYPSO, CALYPSO_DARK);
const ArrowIconUp = styled(UIIcon).withConfig({
  displayName: "ScrollToCta__ArrowIconUp",
  componentId: "sc-1dj4sq2-2"
})(["transform:rotate(-90deg);font-weight:600;"]);
const ArrowIconDown = styled(UIIcon).withConfig({
  displayName: "ScrollToCta__ArrowIconDown",
  componentId: "sc-1dj4sq2-3"
})(["transform:rotate(90deg);font-weight:600;"]);
export const ScrollToCta = ({
  acq117Parameter
}) => {
  const dispatch = useDispatch();
  const [shouldScrollToSignup, setShouldScrollToSignup] = useState(false);
  const [clickedToScroll, setClickedToScroll] = useState(false);

  const scrollToPosition = () => {
    if (shouldScrollToSignup) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setShouldScrollToSignup(false);
    } else {
      const guaranteeBanner = document.querySelector('#guaranteeBanner');

      if (guaranteeBanner) {
        guaranteeBanner.scrollIntoView({
          behavior: 'smooth'
        });
      }

      setShouldScrollToSignup(true);
    }

    setClickedToScroll(true);
  };

  window.onscroll = () => {
    /*
      Check if user has scrolled to the bottom of the page
      (interior height of window in px + number of px the document is scrolled vertically) >= height of document.body
    */
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
      setShouldScrollToSignup(true);
      dispatch(Tracker.signupInteraction(`acq117-${acq117Parameter}-scrolled-to-banner`, {
        ctaClicked: clickedToScroll ? 'yes' : 'no'
      }));
      setClickedToScroll(false);
    } // Number of px the document is currently scrolled vertically is 0 (top of page)


    if (window.scrollY === 0) {
      setShouldScrollToSignup(false);
      dispatch(Tracker.signupInteraction(`acq117-${acq117Parameter}-scrolled-to-signup`, {
        ctaClicked: clickedToScroll ? 'yes' : 'no'
      }));
      setClickedToScroll(false);
    }
  };

  return /*#__PURE__*/_jsxs(ScrollToCtaContainer, {
    align: "center",
    "data-selenium": 'scrollToCta',
    direction: 'row',
    justify: "center",
    children: [shouldScrollToSignup ? /*#__PURE__*/_jsx(ArrowIconUp, {
      color: CALYPSO,
      name: "next",
      size: "small"
    }) : /*#__PURE__*/_jsx(ArrowIconDown, {
      color: CALYPSO,
      name: "next",
      size: "small"
    }), /*#__PURE__*/_jsx(StyledUILink, {
      onClick: () => scrollToPosition(),
      children: /*#__PURE__*/_jsx(ScrollToCtaText, {
        className: "m-left-3",
        message: `guaranteeBanner.${shouldScrollToSignup ? 'scrollToSignup' : 'scrollToBanner'}`
      })
    })]
  });
};